// src/nativeServices.js
// All functions are no-ops on web — safe to call unconditionally.
import { Capacitor } from '@capacitor/core';
import { db } from './firebase';
import { doc, setDoc } from 'firebase/firestore';

export async function initPushNotifications(userId) {
  if (!Capacitor.isNativePlatform()) return;
  const { PushNotifications } = await import('@capacitor/push-notifications');

  const permStatus = await PushNotifications.checkPermissions();
  if (permStatus.receive === 'prompt') {
    const { receive } = await PushNotifications.requestPermissions();
    if (receive !== 'granted') return;
  }
  if (permStatus.receive !== 'granted') return;

  await PushNotifications.register();

  await PushNotifications.addListener('registration', async ({ value: token }) => {
    await setDoc(doc(db, 'deviceTokens', userId), {
      token,
      platform: Capacitor.getPlatform(),
      updatedAt: new Date(),
    });
  });

  await PushNotifications.addListener('registrationError', err => {
    console.error('Push registration error:', err);
  });
}

export async function getBiometryInfo() {
  if (!Capacitor.isNativePlatform()) return { isAvailable: false };
  try {
    const { BiometricAuth } = await import('@aparajita/capacitor-biometric-auth');
    return await BiometricAuth.checkBiometry();
  } catch {
    return { isAvailable: false };
  }
}

export async function authenticateWithBiometrics() {
  if (!Capacitor.isNativePlatform()) return false;
  try {
    const { BiometricAuth } = await import('@aparajita/capacitor-biometric-auth');
    await BiometricAuth.authenticate({
      reason: 'Verify your identity to sign in',
      cancelTitle: 'Use password instead',
      allowDeviceCredential: true,
    });
    return true;
  } catch {
    return false;
  }
}
